module.exports = {"numberOfTickets":"Select how many tickets you want: - FR","addToCart":"Add to cart - FR","checkout":"Checkout - FR","credit":"Credit Ticket Sales To: - FR","ticketSelection":"Ticket selection - FR","selectArtist":"Select an Artist","noTickets":"No more tickets available"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/GeneralSeating/locales/fr.json
// module id = 1166
// module chunks = 0